import {
  PRIVACY_POLICY,
  TERMS_OF_SERVICE,
} from 'shared/constants/urls';
import React, { useState } from 'react';
import { Form, Input, Checkbox, Alert, Result } from 'antd';
import { gql } from '@apollo/client';
import { useMutation } from 'hooks/apollo';
import ModalForm from 'components/ModalForm';

const urlPattern = new RegExp('^(https?:\\/\\/)?' // validate protocol
  + '(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}' // validate domain name
  + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // validate port and path
  + '(\\?[;&a-z\\d%_.~+=-]*)?' // validate query string
  + '(\\#[-a-z\\d_]*)?$', 'i'); // validate fragment locator

const termsValidation = {
  required: true,
  transform: value => (value || undefined),
  type: 'boolean',
};

const SIGNUP_MUTATION = gql`
  mutation FreeTrialSignUp($input: FreeTrialSignUpInput!) {
    freeTrialSignUp(input: $input)
  }
`;

const FreeTrialSignUpModal = ({ open, onCancel }) => {
  const [error, setError] = useState(null);
  const [signedUp, setSignedUp] = useState(false);
  const [signUp] = useMutation(SIGNUP_MUTATION);

  const onFinish = async (values) => signUp({
    variables: {
      input: values,
    },
  });

  return (
    <ModalForm open={open} onCancel={onCancel} onSubmit={onFinish} title="Start your free trial" onSuccess={() => setSignedUp(true)} onError={setError} footer={signedUp ? null : undefined} okText="Sign up">
      {signedUp ? (
        <Result
          status="success"
          title="Sign up successful"
          subTitle={(
            <p>
              Check your email for an activation link to complete the registration.
            </p>
          )}
        />
      ) : (
        <>
          <Form.Item
            name="email"
            label="Email"
            validateFirst
            rules={[
              { required: true, type: 'email', message: 'Enter a valid email' },
            ]}
          >
            <Input type="email" autoComplete="email" />
          </Form.Item>
          <Form.Item
            name="url"
            label="The website you want to use Extellio on"
            validateFirst
            rules={[
              { required: true, pattern: urlPattern, message: 'Enter a valid url' },
            ]}
          >
            <Input placeholder="www.website.com" />
          </Form.Item>
          <Form.Item name="privacyPolicyAndToS" valuePropName="checked" rules={[{ ...termsValidation, message: 'You need to accept the privacy policy and terms of service' }]}>
            <Checkbox>
              I have read and agree to the
              {' '}
              <a href={PRIVACY_POLICY} target="_blank">Privacy policy</a>
              {' '}
              and the
              {' '}
              <a href={TERMS_OF_SERVICE} target="_blank">Terms of service</a>
            </Checkbox>
          </Form.Item>
          {error && (
            <Form.Item>
              <Alert showIcon type="error" message="Sign up failed" description={error} />
            </Form.Item>
          )}
        </>
      )}
    </ModalForm>
  );
};

export default FreeTrialSignUpModal;
